export const getPayrollTaxes = (state) => state.taxes
export const getPayrollTaxeTypes = (state) => state.types
